import React from "react";
import { CountrySelectionDropDown } from "../../../../../common/components/CountrySelectionDropDown";
import { CountrySelectProps } from "../../../../SharedAddressInput/types";
import { getCountryValue } from "../../../mappers";

export const SepaAddressCountrySelect: React.FC<CountrySelectProps> = ({
  name,
  className,
  isFull,
  placeholder,
  handleChange,
  label,
}) => {
  return (
    <CountrySelectionDropDown
      name={name}
      className={className}
      isFull={isFull}
      placeholder={placeholder}
      handleChange={handleChange}
      getValue={getCountryValue}
      label={label}
    />
  );
};
